<button #downloadPdf mat-raised-button color="accent" [style.display]="enableDownload === true ? 'block' : 'none'"
        (click)="generatePDF()">{{'DOWNOLOAD_FILE.GENERATE_PDF' | translate}}</button>